import { MAX_UNREAD_NOTIFICATION_COUNT, NotificationTypeEnum } from '../../../../shared/NotificationTypes.ts';
import { UINotificationItemView } from './UINotificationItemView.ts';
import { UINotificationSendHelper } from './UINotificationSendHelper.ts';
import { UICTANotificationView } from './UICTANotificationView.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { UIUtilsNotifications } from './UIUtilsNotifications.ts';
import { UIUtilsFriends } from '../ui_friends/UIUtilsFriends.ts';
import { setElementOnClick } from '../ui_utils/DomUtils.ts';
export class UINotificationPanelController {
    setLazyLoadAction() {
        this.notificationPanelContent.addEventListener('scroll', (e)=>{
            if (this.lazyLoadingDisabled) return;
            const isBottomReached = this.notificationPanelContent.scrollTop + this.notificationPanelContent.clientHeight >= this.notificationPanelContent.scrollHeight - this.lazyLoadDOMTolerance;
            if (isBottomReached == false) return;
            this.getOlderNotificationsThrottled();
        });
    }
    getOlderNotificationsThrottled() {
        const now = new Date();
        const timeSinceLastRequest = now.getTime() - this.timeOfLastNotificationRequest.getTime();
        if (timeSinceLastRequest < this.LAZY_LOAD_THROTTLE_MS) return;
        const lastNotification = this.notifications[this.notifications.length - 1];
        UINotificationSendHelper.getNotificationsAfterDate(lastNotification.dateReceived);
        this.timeOfLastNotificationRequest = now;
    }
    hideNotificationPanel() {
        this.notificationPanel.classList.add('hidden');
    }
    showNotificationContainer() {
        this.notificationContainer.classList.remove('hidden');
    }
    onNotificationIconClick() {
        this.notificationPanel.classList.toggle('hidden');
    }
    hidePanelIfClickedOutside(event) {
        const target = event.target;
        const targetInsidePanel = this.notificationPanel.contains(target);
        const targetInsideIcon = this.notificationIcon.contains(target);
        if (targetInsidePanel) return;
        if (targetInsideIcon) return;
        this.hideNotificationPanel();
    }
    addNotification(notificationData) {
        const notificationIdx = this.findNotificationById(notificationData.id);
        if (notificationIdx > -1) return;
        const notificationItem = new UINotificationItemView(notificationData, this.notificationPanelContent);
        notificationItem.setCallbackOnClick(()=>this.removeCTANotification(notificationItem));
        notificationItem.setOnClose(()=>this.hideNotificationPanel());
        this.notificationPanelContent.appendChild(notificationItem.container);
        this.notifications.push(notificationItem);
        this.sortNotificationViewsByDateReceived();
    }
    sortNotificationViewsByDateReceived() {
        this.notifications.sort((a, b)=>b.dateReceived.getTime() - a.dateReceived.getTime());
        for (const notification of this.notifications)this.notificationPanelContent.removeChild(notification.container);
        for (const notification of this.notifications)this.notificationPanelContent.appendChild(notification.container);
    }
    sendMarkAllNotificationsAsRead() {
        const unreadNotificationsExist = this.notifications.some((notificationView)=>!notificationView.isRead);
        if (unreadNotificationsExist == false) return;
        UINotificationSendHelper.sendMarkAllNotificationsAsRead();
    }
    addNotifications(notifications) {
        if (notifications.length == 0) this.lazyLoadingDisabled = true;
        for (const notificationData of notifications)this.addNotification(notificationData);
        this.noNotificationsMessage.classList.toggle('hidden', this.notifications.length > 0);
        this.addNotificationCallback();
    }
    markNotificationAsRead(notificationId) {
        const notification = this.notifications.find((notificationView)=>notificationView.notificationId == notificationId);
        notification === null || notification === void 0 ? void 0 : notification.removeUnreadIcon();
    }
    markAllNotificationsAsRead() {
        for (const notification of this.notifications)notification.removeUnreadIcon();
    }
    displayNumberOfUnreadNotifications(unreadNotificationCount) {
        const countOfNotificationsWithCTAs = this.notifications.filter((notification)=>notification.hasCTAs).length;
        unreadNotificationCount = unreadNotificationCount + countOfNotificationsWithCTAs;
        const shouldCapUnreadNotificationCount = unreadNotificationCount > MAX_UNREAD_NOTIFICATION_COUNT - 1;
        const unreadNotificationCountToDisplay = shouldCapUnreadNotificationCount ? `${MAX_UNREAD_NOTIFICATION_COUNT - 1}+` : unreadNotificationCount.toString();
        this.notificationIconUnreadNumber.innerText = unreadNotificationCountToDisplay;
        this.notificationIconUnreadContainer.classList.toggle('hidden', unreadNotificationCount == 0);
        this.lastUnreadNotificationCount = unreadNotificationCount - countOfNotificationsWithCTAs;
    }
    addCTANotification(notificationData) {
        const newCTANotification = new UICTANotificationView(notificationData, this.notificationPanelContent);
        newCTANotification.setCallbackOnClick(()=>this.removeCTANotification(newCTANotification));
        this.notificationPanelContent.appendChild(newCTANotification.container);
        this.notifications.push(newCTANotification);
        this.sortNotificationViewsByDateReceived();
        this.displayNumberOfUnreadNotifications(this.lastUnreadNotificationCount);
        this.noNotificationsMessage.classList.toggle('hidden', this.notifications.length > 0);
        return newCTANotification;
    }
    removeCTANotification(notificationView) {
        const index = this.notifications.indexOf(notificationView);
        if (index == -1) return;
        this.notifications.splice(index, 1);
        this.notificationPanelContent.removeChild(notificationView.container);
        this.displayNumberOfUnreadNotifications(this.lastUnreadNotificationCount);
        notificationView.container.remove();
        this.noNotificationsMessage.classList.toggle('hidden', this.notifications.length > 0);
    }
    updateNotificationTimestamps() {
        for (const notification of this.notifications)notification.updateTimestamp();
    }
    findNotificationById(id) {
        return this.notifications.findIndex((notification)=>notification.notificationId == id);
    }
    addFriendRequestNotification(username, dateCreated) {
        if (this.cachedFriendRequests.includes(username)) return;
        this.cachedFriendRequests.push(username);
        const notificationData = {
            dateReceived: dateCreated,
            typeData: {
                type: NotificationTypeEnum.FriendRequestReceived,
                username: username
            }
        };
        const ctaNotification = this.addCTANotification(notificationData);
        this.userNameNotificationMap.set(username, ctaNotification);
    }
    constructor(addNotificationCallback){
        this.notifications = [];
        this.lazyLoadDOMTolerance = 1;
        this.lastUnreadNotificationCount = 0;
        this.timeOfLastNotificationRequest = new Date();
        this.LAZY_LOAD_THROTTLE_MS = 500;
        this.lazyLoadingDisabled = false;
        this.UPDATE_NOTIFICATION_TIMESTAMP_MS = 5000;
        this.userNameNotificationMap = new Map();
        this.cachedFriendRequests = [];
        this.addNotificationCallback = addNotificationCallback;
        this.notificationIcon = document.getElementById('header_profile_notification_icon');
        this.notificationContainer = document.getElementById('header_profile_notification_container');
        this.notificationPanel = document.getElementById('header_profile_notification_panel');
        this.notificationPanelContent = document.getElementById('header_profile_notification_panel_content');
        this.notificationIconUnreadNumber = document.getElementById('header_profile_notification_count');
        this.notificationIconUnreadContainer = document.getElementById('header_profile_notification_count_container');
        this.markAllAsReadButton = document.getElementById('header_profile_btn_mark_all_as_read');
        this.noNotificationsMessage = document.getElementById('header_profile_notification_no_notifications');
        ClientUserState.registerChangeListener(()=>{
            if (UIUtilsNotifications.canUseLiveNotificationService()) this.showNotificationContainer();
        });
        setElementOnClick(this.notificationIcon, ()=>this.onNotificationIconClick());
        setElementOnClick(this.markAllAsReadButton, ()=>this.sendMarkAllNotificationsAsRead());
        document.addEventListener('pointerdown', (event)=>this.hidePanelIfClickedOutside(event));
        setInterval(()=>this.updateNotificationTimestamps(), this.UPDATE_NOTIFICATION_TIMESTAMP_MS);
        this.setLazyLoadAction();
        const notificationPanelHeaderBackButton = document.getElementById('header_profile_notification_panel_header_back_button');
        if (notificationPanelHeaderBackButton != undefined) setElementOnClick(notificationPanelHeaderBackButton, ()=>this.hideNotificationPanel());
        UIUtilsFriends.setCallbackFriendRequestResponded(async (target, isAccepted)=>{
            const ctaNotification = this.userNameNotificationMap.get(target.username);
            if (ctaNotification == undefined) return;
            this.removeCTANotification(ctaNotification);
        });
    }
}
